import type { SVGProps } from "react";
import * as React from "react";
const SvgDiscord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#5865F2"
      d="M18.942 5.256A16.668 16.668 0 0 0 14.816 4c-.178.311-.386.73-.529 1.063a15.632 15.632 0 0 0-4.573 0A11.218 11.218 0 0 0 9.18 4c-1.448.243-2.834.67-4.129 1.26-2.611 3.823-3.319 7.55-2.965 11.226a16.704 16.704 0 0 0 5.06 2.512c.408-.543.771-1.12 1.084-1.729-.596-.22-1.167-.49-1.706-.805a8.44 8.44 0 0 0 .418-.32c3.29 1.49 6.866 1.49 10.118 0 .137.11.277.218.418.32-.54.316-1.113.587-1.71.807.314.607.675 1.186 1.084 1.729a16.668 16.668 0 0 0 5.064-2.514c.415-4.26-.71-7.955-2.973-11.23Zm-10.264 8.97c-.988 0-1.798-.894-1.798-1.982s.792-1.983 1.798-1.983c1.005 0 1.815.893 1.798 1.983.001 1.088-.793 1.982-1.798 1.982Zm6.644 0c-.988 0-1.798-.894-1.798-1.982s.793-1.983 1.798-1.983c1.006 0 1.816.893 1.798 1.983 0 1.088-.793 1.982-1.798 1.982Z"
    />
  </svg>
);
export default SvgDiscord;
